module.exports = __webpack_public_path__ + "static/media/02․05.f1d72616.jpg";